import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import { useTheme } from "../../context/ThemeContext";

/**
 * 3-column grid of label/count cells showing the size of the domain's
 * various entity collections. Each count is the `total` field from a
 * standard list endpoint (?pagesize=1).
 *
 *   <NtFootprintGrid items={[{label:"Extensions", value:280}, ...]} />
 */
function NtFootprintGrid({ items = [], containerStyle }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const rowsCount = Math.ceil(items.length / 3);

  return (
    <View style={[styles.container, containerStyle]}>
      {items.map((item, idx) => {
        const col = idx % 3;
        const row = Math.floor(idx / 3);
        const isLastCol = col === 2;
        const isLastRow = row === rowsCount - 1;
        return (
          <View
            key={item.label}
            style={[
              styles.cell,
              !isLastCol && styles.cellBorderRight,
              !isLastRow && styles.cellBorderBottom,
            ]}
          >
            <NtText style={styles.label}>{item.label}</NtText>
            <NtText style={styles.value}>{item.value ?? "—"}</NtText>
          </View>
        );
      })}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: { flexDirection: "row", flexWrap: "wrap" },
    cell: {
      width: "33.3333%",
      paddingHorizontal: 14,
      paddingVertical: 10,
    },
    cellBorderRight: {
      borderRightWidth: 1,
      borderRightColor: t.borderSoft,
    },
    cellBorderBottom: {
      borderBottomWidth: 1,
      borderBottomColor: t.borderSoft,
    },
    label: {
      fontSize: 10,
      color: t.textMute,
      fontWeight: "600",
      letterSpacing: 0.6,
      textTransform: "uppercase",
    },
    value: {
      fontSize: 17,
      fontWeight: "700",
      color: t.text,
      marginTop: 3,
      letterSpacing: -0.2,
      fontVariant: ["tabular-nums"],
      fontFamily: t.fontMono,
    },
  });

export default NtFootprintGrid;
